import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import EducationExperience from './EducationExperience';
import SkillsContent from '../../components/SkillsContent';

const ResumePage = () => {
    // Apply page-specific body classes on mount/unmount
    useEffect(() => {
        const bodyClassList = document.body.classList;
        bodyClassList.add('inner-page', 'resume');

        return () => {
            bodyClassList.remove('inner-page', 'resume');
        };
    }, []);

    const bannerProps = {
        page: {
            title: 'Resume',
        },
    };

    return (
        <>
            <Preloader />
            <Banner {...bannerProps} />
            <main className="resume-main-content">
                <EducationExperience />
                <SkillsContent />
            </main>
        </>
    );
};

export default ResumePage;
